import { useDispatch, useSelector } from 'react-redux';

import { updateSiteLanguage } from '../../../../store/reducer';
import { RootState } from '../../../../store';

import { languageList } from '../../../../utils/contant';
import { setValueInLocalStorage } from '../../../../utils/common';
import { HeaderContainer, InfoContainer } from './style';
import { DropdownField } from '../../../../components/FormComponents';

import darzeeLogo from '../../../../assets/images/darzeeLogo.svg';

import { useGetSiteConstantValue } from '../../../../utils/hooks/useGetSiteConstantValue';

const INFO_ITEMS = [
  {
    label: 'Home',
    url: 'https://www.darzeeapp.com/',
  },
  {
    label: 'About us',
    url: 'https://www.darzeeapp.com/about-us',
  },
  {
    label: 'Blog',
    url: 'https://www.darzeeapp.com/blog',
  },
  {
    label: 'Help Center',
    url: 'https://www.darzeeapp.com/help-center',
  },
];

const Header = () => {
  const dispatch = useDispatch();

  const { commonDataReducer } = useSelector((state: RootState) => state);

  const currLang = commonDataReducer.currLang;

  const { getSiteConstantValue } = useGetSiteConstantValue();

  const handleItemClick = (url: string) => {
    window.open(url, '_blank');
  };

  const handleChangeLanguage = (obj: any) => {
    setValueInLocalStorage('currLang', obj);
    dispatch(updateSiteLanguage({ data: obj }));
  };

  return (
    <HeaderContainer>
      <img src={darzeeLogo} alt="Darzee Logo" />
      <div className="right-container">
        <DropdownField options={languageList} value={currLang} onChange={handleChangeLanguage} />

        <InfoContainer>
          {INFO_ITEMS.map((item) => (
            <div className="item" key={item.label} onClick={() => handleItemClick(item.url)}>
              {getSiteConstantValue('login', item.label)}
            </div>
          ))}
        </InfoContainer>
      </div>
    </HeaderContainer>
  );
};

export default Header;
